import ReactNativePlatform from "react-native-web/dist/exports/Platform";
var Platform = {
  OS: ReactNativePlatform.OS
};
export default Platform;